export class MealUserEntity {
  id?: string
  companyUserId?: number
  companyUserDisplayName?: string | null
  mealTierId?: number
  mealTierName?: string | null
  mealTierIconUrl?: string | null
  createdAt?: string
}
